import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { ERRORMESSAGE , POSTION } from "@/utils/constant";
import { validateName, validateMobile, validateEmail, validateAboutYou } from '@/utils/validation';
import { contactUsApi } from '@/components/action/easycampus';
import Popup from './popup';
import Link from 'next/link';

const Contactform = () => {
  // Consts
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [aboutYou, setAboutYou] = useState("");
  const [addForm, setAddForm] = useState("");
  const [demoForm, setDemoForm] = useState(false);
  const [formMessage, setFormMessage] = useState("");

  // Error Messages
  const [nameErrorMessage, setNameErrorMessage] = useState("");
  const [lastNameErrorMessage, setLastNameErrorMessage] = useState("");
  const [mobileErrorMessage, setMobileErrorMessage] = useState("");
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  const [aboutYouErrorMessage, setAboutYouErrorMessage] = useState("");

  // Ref focus for input field
  const nameInputRef = useRef(null);
  const lastNameInputRef = useRef(null);
  const mobileInputRef = useRef(null);
  const emailInputRef = useRef(null);
  const aboutYouInputRef = useRef(null);

  // HANDLE methods
  const handleName = (e) => {
    if (e.target.value.trim() === "") {
      setNameErrorMessage(ERRORMESSAGE.NAME_IS_REQUIRED);
      nameInputRef.current.focus();
    } else {
      setNameErrorMessage(validateName(e.target.value.trim()));
      nameInputRef.current.focus();
    }
    setName(e.target.value);
  };

  const handleLastName = (e) => {
    if (e.target.value.trim() === "") {
    } 
    else {
      setLastNameErrorMessage(validateName(e.target.value.trim()));
      lastNameInputRef.current.focus();
    }
    setLastName(e.target.value);
  };

  const handleMobile = (e) => {
    if (e.target.value.trim() === "") {
      setMobileErrorMessage(ERRORMESSAGE.MOBILE_NUMBER_IS_REQURED);
      mobileInputRef.current.focus();
    } else {
      setMobileErrorMessage(validateMobile(e.target.value.trim()));
      mobileInputRef.current.focus();
    }
    setMobile(e.target.value);
  };

  const handleEmail = (e) => {
    if (e.target.value.trim() === "") {
      setEmailErrorMessage(ERRORMESSAGE.EMAIL_IS_REQURED);
      emailInputRef.current.focus();
    } else {
      setEmailErrorMessage(validateEmail(e.target.value.trim()));
      emailInputRef.current.focus();
    }
    setEmail(e.target.value);
  };

  const handleaboutYou = (e) => {
    if (e.target.value.trim() === "") {
      setAboutYouErrorMessage(ERRORMESSAGE.MESSAGE_IS_REQUIRED);
      aboutYouInputRef.current.focus();
    } else {
      setAboutYouErrorMessage(validateAboutYou(e.target.value.trim()));
      aboutYouInputRef.current.focus();
    }
    setAboutYou(e.target.value);
  }

  const handleDemoForm = () => {
    setAddForm("add");
    setDemoForm(true);
  };

  const handleCombined = () => {
    handleFormSubmit();
    handleDemoForm();
  };

  // form Submit 
  // const handleFormSubmit = async (e) => {
    const handleFormSubmit = (e) => {
      e.preventDefault();
      setName("");
      setLastName("");
      setMobile("");
      setEmail("");
      setAboutYou("");
      setNameErrorMessage("");
      setLastNameErrorMessage("");
      setMobileErrorMessage("");
      setEmailErrorMessage("");
      setAboutYouErrorMessage("");
  
      if (!name) {
        setNameErrorMessage(ERRORMESSAGE.NAME_IS_REQUIRED);
      } else if (name) {
        setNameErrorMessage(validateName(name.trim()));
      }
  
      if (lastName) {
        setLastNameErrorMessage(validateName(lastName.trim()));
      }
  
      if (!mobile) {
        setMobileErrorMessage(ERRORMESSAGE.MOBILE_NUMBER_IS_REQURED);
      } else if (mobile) {
        setMobileErrorMessage(validateMobile(mobile.trim()));
      }
  
      if (!email) {
        setEmailErrorMessage(ERRORMESSAGE.EMAIL_IS_REQURED);
      } else if (email) {
        setEmailErrorMessage(validateEmail(email.trim()));
      }
  
      if (!aboutYou) {
        setAboutYouErrorMessage(ERRORMESSAGE.MESSAGE_IS_REQUIRED);
      } else if (aboutYou) {
        setAboutYouErrorMessage(validateAboutYou(aboutYou.trim()));
      }
  
      // For Focus
  
      if (!name) {
        nameInputRef.current.focus();
        return;
      } else if (name) {
        if (validateName(name.trim())) {
          nameInputRef.current.focus();
          return;
        }
      }
  
      if (lastName) {
        if (validateName(lastName.trim())) {
          lastNameInputRef.current.focus();
          return;
        }
      }
  
      if (!mobile) {
        mobileInputRef.current.focus();
        return;
      } else if (mobile) {
        if (validateMobile(mobile.trim())) {
          mobileInputRef.current.focus();
          return;
        }
      }
  
      if (!email) {
        emailInputRef.current.focus();
        return;
      } else if (email) {
        if (validateEmail(email.trim())) {
          emailInputRef.current.focus();
          return;
        }
      }
  
      if (!aboutYou) {
        aboutYouInputRef.current.focus();
        return;
      } else if (aboutYou) {
        if (validateAboutYou(aboutYou.trim())) {
          aboutYouInputRef.current.focus();
          return;
        }
      }
  
      let formData = {
        firstName: name,
        lastName: lastName,
        email: email,
        mobile: mobile,
        message: aboutYou,
      }
  
      contactUsDataSubmit(formData);
      console.log("formData", formData);
  
    };
  const contactUsDataSubmit = async (formData) => {
    console.log("lets talk", formData);
    try {

      const response = await contactUsApi(formData);

      if (response.data.hasError == false) {
        setFormMessage(response.data);
        console.log("lets talk formsumbit", response.data.data);
        setDemoForm(true)
      }

      if (response.data.hasError === true) {
        setFormMessage(response.data);
        setDemoForm(true)
      }

    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
    <section className='bg-[#e6edef] py-14'>
    {demoForm && (
          <Popup
            isOpen={demoForm}
            onClose={() => setDemoForm(false)}
            message={formMessage}
          />
        )}
     <div className='grid grid-cols-1 lg:grid-cols-12 2xl:mx-24 xl:mx-20 lg:mx-20 md:mx-20 sm:mx-10 mx-5 mb-10 gap-10'>
       <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className='col-span-1 lg:col-span-6 '
      >
        <div className='rounded-[15px]'>
          <div className='px-12 '>
            <h2 className='text-[#1e336a] font-extrabold'>Message Us</h2>
            <p className='py-3'>Let's discuss your business needs or if have any questions, comments, or suggestions? Simply fill in the form and we will be in touch shortly.</p>
            <div className='py-2 mt-5 font-bold'>
              Corporate Address:
            </div>
            <div className='pb-2'>
              <p>Building No 90, <br/>Lower Ground Floor, Sector 44, <br/> Gurugram, Haryana -122003</p>
            </div>
            <div className='py-2 h3'>
              <span className='flex'>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-5 h-5">
                  <path d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
                </svg>
                <Link href='tel:+91-124-4944090' target="_blank" rel="noopener noreferrer" className="ml-2 cursor-pointer">
                +91 124-4944090
                </Link>
              </span>
            </div>
            <div className='py-2 cursor-pointer h3'>
              <span className='flex'>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-5 h-5">
                  <path d="M21.75 9v.906a2.25 2.25 0 0 1-1.183 1.981l-6.478 3.488M2.25 9v.906a2.25 2.25 0 0 0 1.183 1.981l6.478 3.488m8.839 2.51-4.66-2.51m0 0-1.023-.55a2.25 2.25 0 0 0-2.134 0l-1.022.55m0 0-4.661 2.51m16.5 1.615a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V8.844a2.25 2.25 0 0 1 1.183-1.981l7.5-4.039a2.25 2.25 0 0 1 2.134 0l7.5 4.039a2.25 2.25 0 0 1 1.183 1.98V19.5Z" />
                </svg>
                <Link href='mailTo:info@easycampus.ai' target="_blank" rel="noopener noreferrer" className='ml-2'>info@easycampus.ai</Link>
              </span>
            </div>
          </div>
        </div>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className='col-span-1 lg:col-span-6'
      >
        <div className="max-w-2xl mx-auto bg-white rounded-[15px]" style={{ boxShadow: '0px 0px 10px #51a9ff' }}>
          <div className="py-4 px-6">
            <form action="#" method="POST" onSubmit={handleFormSubmit} className="mt-6">
              <div className="flex flex-wrap -mx-3 mb-4">
                <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
                  <input 
                  type="text" 
                  name="first_name" 
                  placeholder="First Name"
                  value={name}
                  ref={nameInputRef}
                  onChange={handleName}
                    className="w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 transition duration-150" />
                     <div
                          id="nameErrorMessage"
                          className="text-red-500 text-sm"
                        >
                          {nameErrorMessage}
                        </div>
                </div> 
                <div className="w-full md:w-1/2 px-3">
                  <input type="text" 
                  name="last_name" 
                  placeholder="Last Name"
                  value={lastName}
                  onChange={handleLastName}
                  ref={lastNameInputRef}
                    className="w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 transition duration-150" />
                     <div
                          id="lastNameErrorMessage"
                          className="text-red-500 text-sm"
                        >
                          {lastNameErrorMessage}
                        </div>
                </div>
              </div>
              <div className="mb-4">
                <input 
                type="email" 
                name="email" 
                placeholder="Email"
                value={email}
                ref={emailInputRef}
                onChange={handleEmail}
                className="w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 transition duration-150" />
                 <div
                   id="EmailErrorMessage"
                    className="text-red-500 text-sm">
                    {emailErrorMessage}
                  </div>
              </div>
              <div className="mb-4">
                <input
                  type="text"
                  name="phone"
                  placeholder="Mobile Number"
                  ref={mobileInputRef}
                  value={mobile}
                  onChange={handleMobile}
                  pattern="[6789][0-9]{9}"
                  minLength={10}
                  maxLength={10}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, "");
                  }}
                  className="w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 transition duration-150"
                />
                <div id="mobileErrorMessage" className="text-red-500 text-sm">
                  {mobileErrorMessage}
                </div>
              </div>
              <div className="mb-4">
                <textarea name="message" 
                  placeholder="Message" rows="5"
                  onChange={handleaboutYou}
                  ref={aboutYouInputRef}
                  value={aboutYou}
                  minLength={20}
                  className="w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 transition duration-150"></textarea>
                  <div
                        id="aboutYouErrorMessage"
                        className="text-red-500 text-sm">
                        {aboutYouErrorMessage}
                      </div>
              </div>
              <div className="mt-6">
                <button type="submit" onClick={handleFormSubmit} 
                  className="w-full px-4 py-2 text-white bg-[#1e336a] rounded-md hover:bg-[#51A9FF] focus:outline-none focus:bg-indigo-600 transition duration-150 ease-in-out">Send
                  Message</button>
              </div>
            </form>
          </div>
        </div>
      </motion.div>
    </div>
  </section>
    </>
   
  );
}

export default Contactform;
